import {
  UPDATE_SPEAKERS_FILES,
  SPEAKER_FILES_CHANGED,
  WORKING_DYNAMIC_FORM,
  FETCH_ALL_PRODUCT_CATEGORY,
  FETCH_ALL_PRODUCT_SUB_CATEGORY
} from '../actions';
var defaultSpeakerAttachment = [
  { position: 'file1', file: '', filename: '' },
  { position: 'file2', file: '', filename: '' },
  { position: 'file3', file: '', filename: '' },
  { position: 'file4', file: '', filename: '' },
  { position: 'file5', file: '', filename: '' }
];

export function speakerAttachments(state = defaultSpeakerAttachment, action) {
  if (action.type === UPDATE_SPEAKERS_FILES) {
    return action.payload;
  }
  return state;
}

export function speakerAttachmentsChanged(state = false, action) {
  if (action.type === SPEAKER_FILES_CHANGED) {
    return action.payload;
  }
  return state;
}

export function workingDynamicForm(state = [], action) {
  if (action.type === WORKING_DYNAMIC_FORM) {
    return action.payload;
  }
  return state;
}

export function productCategories(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}

export function productSubCategories(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_SUB_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}
